'use client'

import type { Maybe } from '@/frontend-types'
import Script from 'next/script'
import type { FC } from 'react'
import { useEffect } from 'react'
import { z } from 'zod'

export type InstagramEmbedBlockProps = {
	embedCode: string
	embedScript: Maybe<string>
}

const instgrmSchema = z
	.object({
		instgrm: z.object({
			Embeds: z.object({
				process: z.function(),
			}),
		}),
	})
	.transform((obj) => obj.instgrm)

const processEmbeds = () => {
	const res = instgrmSchema.safeParse(window)
	if (res.success) res.data.Embeds.process()
}

const InstagramEmbedBlock: FC<InstagramEmbedBlockProps> = ({ embedCode, embedScript }) => {
	useEffect(processEmbeds, [])
	return (
		<>
			{embedScript && <Script src={embedScript} async onLoad={processEmbeds} />}
			<div className="w-full flex justify-center" dangerouslySetInnerHTML={{ __html: embedCode }} />
		</>
	)
}

export default InstagramEmbedBlock
